// extracted by mini-css-extract-plugin
export var icon = "discount-label-module--icon--e85ca";
export var text = "discount-label-module--text--c9a89";
export var wrapper = "discount-label-module--wrapper--8476a";